import { imageCompressToFile, TImageCompressOptions } from '@flatbiz/utils';
import { FC, InputHTMLAttributes } from 'react';
import { CommonPropsWithChildren } from '../utils/native-props';
import './style.less';

export type UploadProps = {
  accept?: string;
  onChange?: (data: string) => void;
  disableUpload?: boolean;
  capture?: InputHTMLAttributes<unknown>['capture'];
  beforeUpload?: (file: File) => Promise<File> | File;
  onUpload: (file: File) => Promise<string>;
  /** 图片压缩配置 */
  imageCompressOptions?: TImageCompressOptions;
} & CommonPropsWithChildren;

const classPrefix = `v-upload`;

export const Upload: FC<UploadProps> = (props) => {
  const onChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      e.persist();
      const { files } = e.target;
      if (!files || files.length === 0) return;
      let uploadFile = files[0];
      if (props.beforeUpload) {
        uploadFile = await props.beforeUpload(uploadFile);
      }
      const compressFile = await imageCompressToFile(uploadFile, props.imageCompressOptions);
      const respData = await props.onUpload(compressFile);
      props.onChange?.(respData);
      e.target.value = ''; // HACK: fix the same file doesn't trigger onChange
    } catch (error) {
      //
    }
  };

  return (
    <div className={classPrefix}>
      {props.children}
      {!props.disableUpload && (
        <input
          capture={props.capture}
          accept={props.accept}
          multiple={false}
          type="file"
          className={`${classPrefix}-input`}
          onChange={onChange}
        />
      )}
    </div>
  );
};

Upload.defaultProps = {
  disableUpload: false,
  accept: 'image/*',
};
